/* src/app/pages/casos/enviarresultados/enviarresultados.component.scss */
/*# sourceMappingURL=enviarresultados.component.css.map */
